import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "app/components/ui/button";

const tripleNetworkPlansData = [
  {
    data: "15 GB",
    description: "Ideal for part-time platform drivers",
    price: 23,
    features: [
      "15GB of high-speed data",
      "Triple network access (all 3 major US carriers)",
      "Unlimited calls and texts",
      `<span style="font-weight: 600;">FREE</span> Complete Identity Protection included`,
      `<span style="font-weight: 600;">FREE</span> Unlimited data rollover`,
      `<span style="font-weight: 600;">FREE</span> Roaming in 80+ countries`,
      `<span style="font-weight: 600;">FREE</span> Calls to 170+ countries`,
    ],
    link: "/pricing",
  },
  {
    data: "Unlimited",
    description: "Ideal for full-time platform drivers",
    price: 36,
    features: [
      "Unlimited data 🏆",
      "Triple network access (all 3 major US carriers)",
      "Unlimited calls and texts",
      `<span style="font-weight: 600;">FREE</span> Complete Individual Protection Plan included 🏆`,
      `<span style="font-weight: 600;">FREE</span> roaming in 80+ countries`,
      `<span style="font-weight: 600;">FREE</span> calls to 170+ countries`,
      `<span style="font-weight: 600;">FREE</span> home and car title monitoring (VLE mobile's exclusive feature)`,
    ],
    link: "/pricing",
  },
  {
    data: "Family",
    description: "Great for driver families",
    price: 11,
    features: [
      "Triple network access for you and your family 🏆",
      `<span style="font-weight: 600;">FREE</span> Complete Family Security Plan included 🏆`,
      "Add up to 5 lines with individual data allocations",
      `<span style="font-weight: 600;">FREE</span> calls to 170+ countries on all lines`,
      `<span style="font-weight: 600;">FREE</span> roaming in 80+ countries on all lines`,
      "Share your security protection with family members",
    ],
    link: "/pricing",
  },
];

export const PlatformDriverPlans = () => {
  const navigate = useNavigate();

  return (
    <section className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 py-9 sm:py-14 md:py-[5.5rem] lg:py-[7.5rem]">
      <div className="relative mx-auto mb-6 text-center w-fit sm:mb-8 lg:mb-10">
        <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[5.25rem]">
          Platform Driver Plans
        </h2>
        <p className="text-[#1D1D1B] text-[0.925rem] sm:text-base lg:text-lg font-normal leading-5 sm:leading-6 md:leading-7">
          Choose the plan that fits your driving schedule and needs:
        </p>
        <div className="[@media(max-width:436px)]:hidden absolute top-full [@media(min-width:900px)]:top-[42%] [@media(min-width:900px)]:-translate-y-1/2 -right-2 [@media(min-width:900px)]:-right-40 z-[1] max-w-[7.5rem] sm:max-w-32 [@media(min-width:900px)]:max-w-36">
          <div className="flex relative justify-center items-center w-full h-full">
            <p className="max-w-[6.6875rem] absolute z-[2] w-full font-mobile text-white text-center text-xs [@media(min-width:900px)]:text-[0.8125rem] font-medium leading-[0.9rem] sm:leading-4 lg:leading-[1.0625rem] mt-5 mx-auto">
              Now With <br /> Unlimited Data Carryover†
            </p>
            <img
              src="/assets/network-star.webp"
              className="relative z-[1] w-full h-auto"
              alt="Network coverage map"
            />
          </div>
        </div>
      </div>
      <ul className="flex flex-wrap gap-4 justify-center w-full md:gap-5 xl:gap-6 2xl:gap-[1.875rem]">
        {tripleNetworkPlansData.map((identity, index) => (
          <li
            key={index}
            className="flex overflow-hidden relative flex-col w-full rounded-xl max-w-[26rem] sm:rounded-2xl lg:rounded-3xl"
          >
            {index === 1 && (
              <div className="absolute top-0 left-0 bg-[#1D1D1B] w-full h-11 sm:h-[3.15rem] lg:h-16" />
            )}
            <div
              className={`relative z-[1] flex justify-center items-center text-center ${
                index === 2
                  ? "[@media(min-width:1392px)]:h-10"
                  : index === 0
                  ? "[@media(min-width:900px)]:h-9 lg:h-10"
                  : "h-8 sm:h-9 lg:h-10"
              }`}
            >
              {index === 1 && (
                <>
                  <span className="text-white text-sm sm:text-[0.925rem] lg:text-base font-medium leading-4 sm:leading-[1.125rem] lg:leading-5">
                    Most Popular
                  </span>
                  <img
                    src="/assets/sparkles.svg"
                    alt="Sparkles"
                    className="ml-1 size-4 sm:size-[1.125rem]"
                  />
                </>
              )}
            </div>
            <div className="relative flex-1 bg-white w-full pt-3 sm:pt-4 md:pt-5 lg:pt-6 pb-4 sm:pb-5 md:pb-6 lg:pb-[1.875rem] px-5 sm:px-6 md:px-7 lg:px-[1.875rem] xl:px-8 border border-[#EBEBEB] rounded-xl sm:rounded-2xl lg:rounded-3xl">
              <h4 className="text-[#141414] font-mobile text-xl sm:text-[1.375rem] md:text-2xl lg:text-[1.625rem] font-medium leading-7 sm:leading-9 md:leading-10 mb-0.5 sm:mb-1">
                Triple Network - {identity.data} Plan
              </h4>
              <span className="inline-block text-[#141414]/50 text-sm sm:text-[0.925rem] lg:text-base font-normal leading-4 sm:leading-[1.125rem] lg:leading-5 mb-4 sm:mb-5 lg:mb-[1.37rem]">
                {identity.description}
              </span>
              <div className="space-y-0.5 sm:space-y-[0.18rem] mb-4 sm:mb-5 md:mb-6 lg:mb-[1.71rem]">
                <span className="inline-block text-[#7C7C7B] text-xs sm:text-[0.825rem] md:text-sm font-normal leading-3 sm:leading-4 md:leading-[1.08rem]">
                  Starting at
                </span>
                <div className="flex gap-0.5">
                  <span className="text-[#141414] text-lg sm:text-xl md:text-[1.3125rem] font-semibold leading-[1.125rem] sm:leading-5 md:leading-[1.3125rem]">
                    $
                  </span>
                  <p className="text-[#141414] text-[2.125rem] sm:text-4xl md:text-[2.375rem] font-semibold leading-[2.125rem] sm:leading-9 md:leading-[2.375rem]">
                    {identity.price}
                    <span className="text-base sm:text-lg md:text-xl">
                      /mo{identity.data === "Family" ? "/line" : ""}
                    </span>
                  </p>
                </div>
              </div>
              <Button
                type="button"
                variant={index === 1 ? "primary" : "outline"}
                className={`h-11 sm:h-[2.875rem] md:h-12 lg:h-14 border-[#EBEBEB] rounded-[3.125rem] text-xs sm:text-[0.825rem] lg:text-sm font-semibold leading-3 sm:leading-[1.05rem] ${
                  index === 1 ? "" : "hover:bg-[#1414140D] text-[#141414]"
                }`}
                onClick={() => navigate(identity.link)}
              >
                Start Now
              </Button>
              <div className="mt-3 sm:mt-4 md:mt-6 lg:mt-8">
                <h6 className="text-[#141414] text-sm sm:text-[0.925rem] md:text-base font-semibold leading-4 md:leading-[1.125rem] mb-2 sm:mb-2.5 md:mb-3 lg:mb-3.5">
                  Our features:
                </h6>
                <ul className="space-y-1.5 sm:space-y-2 md:space-y-2.5">
                  {identity.features.map((feature, index) => (
                    <li
                      key={index}
                      className="flex items-start gap-[0.375rem] sm:gap-[0.45rem] md:gap-[0.56rem]"
                    >
                      <span className="flex-shrink-0 md:mt-[0.1rem]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="size-4 sm:size-[1.125rem] md:size-5"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M7.5 11L9.16667 12.6667L12.5 9.33334M17.5 11C17.5 15.1422 14.1421 18.5 10 18.5C5.85786 18.5 2.5 15.1422 2.5 11C2.5 6.85787 5.85786 3.5 10 3.5C14.1421 3.5 17.5 6.85787 17.5 11Z"
                            stroke="#2D6956"
                            strokeOpacity="0.92"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <p
                        className="text-[#141414] text-sm sm:text-[0.925rem] md:text-base font-normal leading-[1.125rem] sm:leading-5 md:leading-6"
                        dangerouslySetInnerHTML={{ __html: feature }}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
